import {priority} from '@priority-software/priority-proto-api/lib';

export enum EntityType {
    FORM = 70, // blue
    REPORT = 82, // red
    PROCEDURE = 80, // green
    DOCUMENT = 72, // purple
    WIZARD = 87, // green
    GANTT = 71, // green
    MENU = 77,
    DASHBOARD = 68, // green
    BIREPORT = 79 // green
}

export const EntityClasses = {
    [EntityType.FORM]: 'form-entity',
    [EntityType.REPORT]: 'rep-entity',
    [EntityType.PROCEDURE]: 'proc-entity',
    [EntityType.DOCUMENT]: 'menu-entity',
    [EntityType.WIZARD]: 'wiz-entity'
};

export const SidePanelSubforms = [
    priority.netitems.form.SubformType.Attachments,
    priority.netitems.form.SubformType.ChangeLog,
    priority.netitems.form.SubformType.StatusLog
];
